import LogoutDialog from 'components/AppDialogs/LogoutDialog'
import AppLoading from 'components/AppLoading'
import JobsBoxContainer from 'components/JobsBox/JobsBoxContainer'
import TrailDateCheck from 'components/TrialDate'
import { SNACKBAR_DURATION } from 'config'
import { SnackbarProvider as SnackbarProviderOrig } from 'notistack'
import { Outlet } from 'react-router-dom'

// fixme: type bug of current ver(3.0.1) of notistack (T.T)
const SnackbarProvider = SnackbarProviderOrig as any
import { useRootLoaderData } from './Root.loader'

export default function Root() {
  const rootData = useRootLoaderData()

  if (!rootData) {
    return <AppLoading />
  }

  return (
    <>
      <SnackbarProvider
        maxSnack={3}
        autoHideDuration={SNACKBAR_DURATION}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Outlet />
        <JobsBoxContainer />
      </SnackbarProvider>
      <TrailDateCheck />
      <LogoutDialog />
    </>
  )
}
